import React from "react";
import { object } from "prop-types";

import Organism1 from "./Organism1";
import Organism2 from "./Organism2";
import Organism3 from "./Organism3";
import ComponentContainer from "../../layouts/component-container";
import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";

import { useDevice } from "../../utils/react-utils";

import "./sixStories1WidgetWithPoll.m.css";

const SixStories1WidgetWithPoll = ({ collection }) => {
  if (!(collection && collection.items && collection.items.length)) return null;
  const { tab, desktop } = useDevice();

  const { items = [], "associated-metadata": { number_of_stories_to_show: numOfStories = 3, ad_slot: adSlot } = {} } =
    collection;

  const collectionItems = items.filter(({ type }) => type === "collection").slice(0, 2);

  if (!(collectionItems && collectionItems.length)) return null;

  const [firstCollection = {}, secondCollection = {}] = collectionItems;

  const { "associated-metadata": { show_collection_name_website: showCollectionName1 } = {} } = firstCollection;
  const { "associated-metadata": { show_collection_name_website: showCollectionName2 } = {} } = secondCollection;

  const stories = firstCollection.items?.filter(({ type }) => type === "story") || [];

  if (!stories.length) return null;

  return (
    <ComponentContainer collection={collection}>
      <div styleName="collection-title-wrapper">
        {showCollectionName1 && <CollectionTitleWithArrow collection={firstCollection} styleName="collection-title" />}
        {showCollectionName2 && desktop && (
          <CollectionTitleWithArrow collection={secondCollection} styleName="collection-title" />
        )}
      </div>

      <div styleName="wrapper">
        <div styleName="organism1-wrapper">
          <Organism1 stories={tab ? [stories[0]] : stories.slice(0, 2)} />
        </div>
        <div>
          <Organism2 stories={tab ? stories.slice(1, 6) : stories.slice(2, 6)} />
        </div>
        <div styleName="organism3-wrapper">
          {secondCollection ? (
            <Organism3 collection={secondCollection} adSlot={adSlot} numOfStories={numOfStories} />
          ) : null}
        </div>
      </div>
    </ComponentContainer>
  );
};

SixStories1WidgetWithPoll.propTypes = {
  collection: object,
};

SixStories1WidgetWithPoll.nestedCollectionLimit = [6, 5];

export default SixStories1WidgetWithPoll;
